import { useState } from "react";
import { Anchor, Loader, Text, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { BotProviderType } from "@/API";
import { useBotProviderSendMessage } from "../BotProvider/useBotProviderSendMessage";

export interface ChatBotSendMessageFormProps {
    workspaceId: string;
    botProviderId: string;
    userId: string;
    botProviderType?: BotProviderType;
    isLatestMode: boolean;
    onBackToLatest: () => void;
}

export function ChatBotSendMessageForm({
    workspaceId,
    botProviderId,
    userId,
    botProviderType,
    isLatestMode,
    onBackToLatest,
}: ChatBotSendMessageFormProps) {
    const sendMessageAsync = useBotProviderSendMessage({
        provider: botProviderType ?? "None",
        workspaceId,
        botProviderId,
        userId,
    });
    const [sendMessageLoading, setSendMessageLoading] = useState(false);

    const form = useForm({
        initialValues: {
            text: "",
        },
    });

    return (
        <form
            onSubmit={form.onSubmit(async (values) => {
                if (!isLatestMode) return;
                setSendMessageLoading(true);
                try {
                    await sendMessageAsync([values.text]);
                    form.setFieldValue("text", "");
                } catch (e) {
                    notifications.show({ message: "傳送失敗", color: "red" });
                } finally {
                    setSendMessageLoading(false);
                }
            })}
        >
            <TextInput
                rightSection={sendMessageLoading ? <Loader size="xs" /> : ""}
                disabled={sendMessageLoading || botProviderType === "None" || !isLatestMode}
                placeholder={
                    !isLatestMode
                        ? "非最新歷史紀錄，無法傳送訊息（請先回到最新紀錄）"
                        : "傳送訊息"
                }
                radius="lg"
                {...form.getInputProps("text")}
            />
            {!isLatestMode && (
                <Text size="xs" c="dimmed" ta="center" mt={4}>
                    📌 目前處於時間查找模式，無法傳送訊息。{" "}
                    <Anchor component="button" type="button" size="xs" onClick={onBackToLatest}>
                        點此回到最新紀錄
                    </Anchor>
                </Text>
            )}
        </form>
    );
}
